import React, { MouseEvent, FC } from "react";
import { IconProps } from "@material-ui/core";

import { StyledStarBorder, StyledStarFull, NoStyledButton } from "./styles";

type VoidCallback = () => void;
type EventCallback = (event: MouseEvent<HTMLElement>) => void;

const ToggleStar: FC<ToggleStarProps> = ({
  active,
  onClick,
  activeColor = "#f4b400",
  className,
}) => (
  <NoStyledButton type="button" onClick={onClick}>
    {active ? (
      <StyledStarFull className={className} fillColor={activeColor} />
    ) : (
      <StyledStarBorder className={className} id="tour-star" />
    )}
  </NoStyledButton>
);

export type ToggleStarProps = Omit<IconProps, "onClick"> & {
  active: boolean;
  onClick: VoidCallback | EventCallback;
  activeColor?: string;
};

export default ToggleStar;
